import React from "react";

const GMSFillButton = ({
  name = "",
  type = "button",
  disabled = false,
  fontSize = "14px",
  onClick,
  "data-testid": dataTestId = undefined,
  ...props
}) => {
  return (
    <div>
      <button
        type={type}
        onClick={onClick}
        disabled={disabled}
        className="button-fill"
        data-testid={dataTestId}
      >
        {name}
      </button>
    </div>
  );
};

export default GMSFillButton;
